/**
 * this is an error that occurs if the trade plan we are tracking looks like it has a mismatch in how much qty
 * it thinks it is managing relative to the brokerage. 
 * {
	"messageType": "alertNotification",
	"notificationId": 1645457240753,
	"notificationDetails": {"errorType":"SYSTEM_ERROR","notificationType":"ERROR"},
	"status": "POSITION_QTY_MISMATCH",
	"statusDetails": {"tradePlanPositionQty":40.2,"positionSymbol":"XYZ","brokeragePositionQty":23.1},
	"date": "2022-02-21T10:27:21.728-0500",
	"timestamp": "1645457241728"
}

 * @returns object with fields:
 * 1) tradePlanPositionQty: throughout all the tradeplans, how much qty does TU believe it is managing for a specific system
 * 2) positionSymbol: what is the symbol of that position
 * 3) brokeragePositionQty: how much qty does the brokerage have
 */
export default function positionQtyMismatchParser(statusDetails) {
  const parsedObj = {
    tradePlanPositionQty: null,
    symbol: null,
    brokeragePositionQty: null,
  };
  if (statusDetails) {
    parsedObj.tradePlanPositionQty = statusDetails.tradePlanPositionQty ?? null;
    parsedObj.symbol = statusDetails.positionSymbol ?? null;
    parsedObj.brokeragePositionQty = statusDetails.brokeragePositionQty ?? null;
  }
  return parsedObj;
}
